import { Alert, TextInput } from '@mantine/core';
import api from '../../api/api';
import { displayErrorOnReactHookForm } from '@/utils/error/errorHandler';
import { useForm } from 'react-hook-form';
import { useAuth } from '@/AuthProvider';
import { useNavigate } from 'react-router-dom';
import { FormModal } from './FormModal';
import { IconInfoCircle } from '@tabler/icons-react';

interface ChangeEmailModalProps {
  opened: boolean;
  onClose: () => void;
  currentEmail: string;
}

interface ChangeEmailRequest {
  email: string;
  confirmEmail: string;
}

export const ChangeEmailModal = ({
  opened,
  onClose,
  currentEmail,
}: ChangeEmailModalProps) => {
  const navigate = useNavigate();
  const { setToken } = useAuth();

  const {
    register,
    handleSubmit,
    setError,
    formState: { errors },
    getValues,
  } = useForm<ChangeEmailRequest>();

  const onSubmit = handleSubmit(
    async (changeEmailRequest: ChangeEmailRequest) => {
      try {
        await api.put('/users/me', changeEmailRequest);
        onClose();
        setToken(null);
        navigate('/login');
      } catch (error: any) {
        displayErrorOnReactHookForm(error, setError);
      }
    }
  );

  return (
    <FormModal
      onConfirm={onSubmit}
      opened={opened}
      onClose={onClose}
      title="Změna emailu"
      size="md"
      confirmText="Uložit email"
    >
      <Alert color="blue" icon={<IconInfoCircle />} radius="md" key={'alert'}>
        Po změně budete odhlášeni ze systému Prosaz.
      </Alert>
      <TextInput
        label="Nový email"
        variant="filled"
        size="md"
        radius="md"
        {...register('email')}
        error={errors.email?.message}
      />
      <TextInput
        label="Zopakujte nový email"
        variant="filled"
        size="md"
        radius="md"
        {...register('confirmEmail', {
          validate: match => {
            return (
              match === getValues('confirmEmail') ||
              'Zadané emaily se neshodují'
            );
          },
        })}
        error={errors.confirmEmail?.message}
      />
    </FormModal>
  );
};
